import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import WarningIcon from "@mui/icons-material/Warning";
import AutorenewTwoToneIcon from "@mui/icons-material/AutorenewTwoTone";

export const ALL_INTEGRATION_UPLOAD_TYPE_OPTIONS = {
    FK_STATS_CSV_SYNC :[
          {
            label: "Listing Update",
            value: "flipkart_csv_stats_sync_write_append",
          },
        ],
    FK_LISTING_CSV_SYNC : [
          { label: "All", value: "flipkart_all" },
          {
            label: "Listing Upload",
            value: "flipkart_csv_listing_sync_over_write",
          },
          {
            label: "Listing Update",
            value: "flipkart_csv_listing_sync_write_append",
          },
        ],
    MYNTRA_STATS_CSV_SYNC :[
          {
            label: "Listing Update",
            value: "myntra_csv_stats_sync_write_append",
          },
        ],
    MYNTRA_LISTING_CSV_SYNC : [
          { label: "All", value: "myntra_all" },
          {
            label: "Listing Upload",
            value: "myntra_csv_listing_sync_over_write",
          },
          {
            label: "Listing Update",
            value: "myntra_csv_listing_sync_write_append",
          },
        ],
    AMAZON_STATS_CSV_SYNC: [
          {
            label: "Listing Update",
            value: "amazon_csv_stats_sync_write_append",
          },
        ],
    AMAZON_LISTING_CSV_SYNC: [
          { label: "All", value: "amazon_all" },
          {
            label: "Listing Upload",
            value: "amazon_csv_listing_sync_over_write",
          },
          {
            label: "Listing Update",
            value: "amazon_csv_listing_sync_write_append",
          },
        ],
};

export const DEFAULT_SELECTED_UPLOAD_TYPE = {
    FK_STATS_CSV_SYNC : "flipkart_csv_stats_sync_write_append",
    FK_LISTING_CSV_SYNC : "flipkart_all",
    MYNTRA_STATS_CSV_SYNC : "myntra_csv_stats_sync_write_append",
    MYNTRA_LISTING_CSV_SYNC : "myntra_all",
    AMAZON_STATS_CSV_SYNC: "amazon_csv_stats_sync_write_append",
    AMAZON_LISTING_CSV_SYNC: "amazon_all",
};
export const UPLOAD_TYPE_FILTER_MAPPING = {
    flipkart_all: [
      {
        field_name: "job_type",
        operator: "IN",
        values: [
          "flipkart_csv_listing_sync_over_write",
          "flipkart_csv_listing_sync_write_append",
        ],
      },
    ],
    flipkart_csv_listing_sync_over_write: [
      {
        field_name: "job_type",
        operator: "EQUALS",
        value: "flipkart_csv_listing_sync_over_write",
      },
    ],
    flipkart_csv_listing_sync_write_append: [
      {
        field_name: "job_type",
        operator: "EQUALS",
        value: "flipkart_csv_listing_sync_write_append",
      },
    ],
    flipkart_csv_stats_sync_write_append: [
      {
        field_name: "job_type",
        operator: "EQUALS",
        value: "flipkart_csv_stats_sync_write_append",
      },
    ],
    myntra_all: [
      {
        field_name: "job_type",
        operator: "IN",
        values: [
          "myntra_csv_listing_sync_over_write",
          "myntra_csv_listing_sync_write_append",
        ],
      },
    ],
    myntra_csv_listing_sync_over_write: [
      {
        field_name: "job_type",
        operator: "EQUALS",
        value: "myntra_csv_listing_sync_over_write",
      },
    ],
    myntra_csv_listing_sync_write_append: [
      {
        field_name: "job_type",
        operator: "EQUALS",
        value: "myntra_csv_listing_sync_write_append",
      },
    ],
    myntra_csv_stats_sync_write_append: [
      {
        field_name: "job_type",
        operator: "EQUALS",
        value: "myntra_csv_stats_sync_write_append",
      },
    ],
    amazon_all: [
      {
        field_name: "job_type",
        operator: "IN",
        values: [
          "amazon_csv_listing_sync_over_write",
          "amazon_csv_listing_sync_write_append",
        ],
      },
    ],
    amazon_csv_listing_sync_over_write: [
      {
        field_name: "job_type",
        operator: "EQUALS",
        value: "amazon_csv_listing_sync_over_write",
      },
    ],
    amazon_csv_listing_sync_write_append: [
      {
        field_name: "job_type",
        operator: "EQUALS",
        value: "amazon_csv_listing_sync_write_append",
      },
    ],
    amazon_csv_stats_sync_write_append: [
      {
        field_name: "job_type",
        operator: "EQUALS",
        value: "amazon_csv_stats_sync_write_append",
      },
    ],
  };


export const statusConfig = {
  validating: {
    icon: <AutorenewTwoToneIcon sx={{ color: "primary.main" }} />,
    bg: "#F7F6FF",
    color: "primary.main",
    title: "Validating file...",
  },
  success: {
    icon: <CheckCircleIcon sx={{ color: "success.main" }} />,
    bg: "#EDF7ED",
    color: "success.main",
    title: "Validation Successful",
  },
  error: {
    icon: <ErrorIcon sx={{ color: "error.main" }} />,
    bg: "#FDEDED",
    color: "#5F2120",
    title: "Validation Failed",
  },
  warning: {
    icon: <WarningIcon sx={{ color: "warning.main" }} />,
    bg: "#FFF4E5",
    color: "#663C00",
    title: "Validation Warning",
  },
};